<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      persistent
      width="750px"
  >
    <form v-if="selectedObject" @submit.prevent="onSubmitObject">
      <v-card class="pa-8">
        <v-tabs v-model="tab">
          <v-tab>Address</v-tab>
          <v-tab>Map</v-tab>
          <v-tab>Picture</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-container class="tab-item">
              <v-row>
                <v-col>
                  <v-text-field
                      v-model="selectedObject.name"
                      class="login-input"
                      hide-details
                      label="ชื่อ"
                      outlined
                      placeholder=""
                      required
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>

                  <v-text-field

                      v-model="selectedObject.address"
                      class="login-input"
                      hide-details
                      label="ที่อยู่"
                      outlined
                      placeholder=""
                      required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">

                  <v-text-field

                      v-model="selectedObject.zip_code"
                      class="login-input"
                      hide-details
                      label="รหัสไปรษณีย์"
                      outlined

                      placeholder=""
                      type="number"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>

                  <v-autocomplete
                      v-model="selectedObject.district_id"
                      :items="districtItems"
                      :loading="isLoadingDistricts"
                      :search-input.sync="search"
                      auto-select-first
                      class="login-input"
                      hide-details
                      hide-no-data

                      item-text="name"
                      item-value="id"
                      label="ตำบล"
                      outlined
                      placeholder="ค้นหา"
                      required
                      return-object
                      @change="changeDistrict"
                  >
                    <template v-slot:item="data">
                      {{ data.item.Description }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.city.name"
                      class="login-input"
                      disabled
                      hide-details
                      label="อำเภอ"
                      outlined
                      placeholder=""
                      readonly
                      required

                  >
                  </v-text-field>


                </v-col>
                <v-col>


                  <v-text-field

                      v-model="selectedObject.province.name"
                      class="login-input"
                      disabled
                      hide-details
                      label="จังหวัด"
                      outlined
                      placeholder=""
                      readonly
                      required
                  >
                  </v-text-field>

                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.contact_name"
                      class="login-input"
                      hide-details
                      label="ผู้ติดต่อ"
                      outlined
                      placeholder=""

                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.contact_tel"
                      class="login-input"
                      hide-details
                      label="เบอร์โทร"
                      outlined
                      placeholder=""
                      type="number"
                  >
                  </v-text-field>

                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="tab-item">
              <v-row>
                <v-col cols="6">
                  <v-card class="pa-2">
                <span class="caption float-right">
                                    <v-btn class="ml-1" x-small @click="editLocation()">แก้ไข</v-btn></span>

                    <span class="caption">แผนที่
                <span v-if="selectedObject.gis_type===CustomerConst.GIS_TYPE_NONE">(ยังไม่ยืนยัน)</span>
                  <span v-if="selectedObject.gis_type===CustomerConst.GIS_TYPE_DISTRICT">(ตำบล)</span>
                  <span v-if="selectedObject.gis_type===CustomerConst.GIS_TYPE_GOOGLE">(จาก google)</span>
                  <span v-if="selectedObject.gis_type===CustomerConst.GIS_TYPE_USER">(ปักแล้ว)</span>
                </span>
                    <v-divider class="mt-2"></v-divider>

                    <a :href="selectedObject.cache_lat>0?`https://maps.google.com/?q=${selectedObject.cache_lat},${selectedObject.cache_lng}`:'#'"
                       :target="selectedObject.cache_lat>0?'_blank':'_self'">
                      <v-img
                          :src="`https://maps.googleapis.com/maps/api/staticmap?center=${selectedObject.district?selectedObject.district.name+'+':''}+${selectedObject.province.name}&size=320x180&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI${selectedObject.cache_lat>0?'&markers=size:small%7Ccolor:red%7Clabel:X%7C'+selectedObject.cache_lat+','+selectedObject.cache_lng+'':'&zoom=12'}`"
                          aspect-ratio="1.6"
                          class="grey lighten-2"
                      >
                        <template v-slot:placeholder>
                          <v-row
                              align="center"
                              class="fill-height ma-0"
                              justify="center"
                          >
                            <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>

                          </v-row>
                        </template>
                      </v-img>
                    </a>
                  </v-card>
                </v-col>
                <v-col v-if="false">
                  <v-card class="pa-2">
                <span class="caption float-right">
                                    <v-btn class="ml-1" x-small @click="editImage()">แนบรูป</v-btn></span>

                    <span class="caption">รูปหน้าร้าน
                </span>
                    <v-divider class="mt-2"></v-divider>

                    <a href="#">
                      <v-img
                          :src="``"
                          aspect-ratio="1.6"
                          class="grey lighten-2"
                      >
                        <template v-slot:placeholder>
                          <v-row
                              align="center"
                              class="fill-height ma-0"
                              justify="center"
                          >
                            <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>

                          </v-row>
                        </template>
                      </v-img>
                    </a>
                  </v-card>
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <div class="red--text">
                    กรุณาตรวจสอบพิกัดและยืนยัน
                    หากส่งสินค้าไปตามพิกัดแล้วไม่ถูกต้องเซล์จะต้องรับผิดชอบค่าใช้จ่ายในการขนส่ง
                  </div>
                  <v-checkbox v-if="selectedObject"
                              v-model="selectedObject.gis_is_confirm"
                              class="mt-0 align-end"
                              hide-details
                              label="ยืนยันพิกัด"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>

          </v-tab-item>
          <v-tab-item>
            <v-container class="tab-item">
              <v-row>
                <v-col cols="12">
                  <v-card
                      class="ma-2 float-left delete-card" v-for="media in medias">
                    <v-img
                        width="148"
                        class="grey lighten-2"
                        :src="media.content"
                    >
                    </v-img>
                    <v-btn @click="deletingMedia(media)"
                           class="delete-image"
                           color="red"
                           fab small>
                      <v-icon color="white" small>mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-file-input
                      class="clickable"
                      accept="image/png, image/jpeg, image/bmp"
                      placeholder="กดเพื่อเพิ่มภาพหน้าร้าน"
                      prepend-icon="mdi-camera"
                      label="รูปหน้าร้าน"
                      hide-input
                      large
                      @change="onImagePicked"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" color="gray" text @click="cancel">
            ยกเลิก
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button" color="primary" fab
                 tile
                 type="submit"
                 width="100">
            <!--<v-icon>mdi-check-bold</v-icon>-->
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>

  </v-dialog>
</template>
<style lang="scss" scoped>

#location-picker {
  width: 100%;
  height: 400px;
}

.tab-item {
  min-height: 400px;
}

.delete-card {
  position: relative;

  .delete-image {
    position: absolute;
    top: -10px;
    right: -10px;
  }
}

</style>

<script lang="ts">
import {City} from '@/models/City'
import {CustomerConst} from '@/models/Customer'
import {CustomerAddress} from '@/models/CustomerAddress'
import {District} from '@/models/District'
import {Media} from '@/models/Media'
import {SimpleResponse} from '@/models/Model'
import {Province} from '@/models/Province'
import {Truck} from '@/models/Truck'
import Helper from '@/services/Helper'
import {Component, Vue, Watch} from 'vue-property-decorator'


@Component({
  components: {}
})
export default class AddressDialog extends Vue {
  index: number = 0
  open: boolean = false
  selectedObject: CustomerAddress | null = null
  objectArray: CustomerAddress[] = []

  objectLoading = false
  CustomerConst = CustomerConst
  entries = [{
    id: '00000',
    name: '',
    'province_id': 0,
    city: {
      name: '',
      province: {
        name: ''
      }
    }
  }]
  // countDistricts = 0
  isLoadingDistricts = false
  search = ''

  tab = 0

  get districtItems() {
    return this.entries.map(entry => {
      let district = entry.name

      if (!entry.hasOwnProperty('city')) {
        return Object.assign({}, entry, {
          id: '00000',
          name: district,
          city: '',
          province: '',
          Description: district
        })
      }

      let city = entry.city.name
      let province = entry.city.province.name
      if (entry.province_id == 10) {
        district = 'แขวง' + district
        // city =  city
        province = '' + province
      } else {
        district = 'ต.' + district
        // city =  city
        // province = province
      }
      const Description = entry.name + ' > ' + entry.city.name + ' > ' + entry.city.province.name
      return Object.assign({}, entry, {
        id: entry.id,
        name: district,
        city: city,
        province: province,
        Description
      })
    })
  }

  async onSubmitObject() {



    this.objectLoading = true

    if (this.selectedObject) {
      this.selectedObject.medias = this.medias
      await this.onApply(this.selectedObject)
    }
    this.objectLoading = false
    this.open = false
  }

  cancel() {
    this.open = false
  }

  onApply: Function = (address: CustomerAddress | null) => {
  }

  created() {
    this.$root.$on('openAddress', this.onOpen)
  }

  onOpen({id, address, addresses, index, debug, skip_load, onApply}) {
    if (this.open) return
    console.log('Emited', {address, addresses, index, debug})
    this.medias = []
    this.tab = 0
    this.selectedObject = new CustomerAddress()
    if (address) {
      this.selectedObject = address

      if (address.medias === undefined || address.medias === null) {
        address.medias = []
      } else {
        this.medias = address.medias
      }
      if (address.district === undefined || address.district === null) {
        address.district = new District()
      }
      if (address.city === undefined || address.city === null) {
        address.city = new City()
      }
      if (address.province === undefined || address.province === null) {
        address.province = new Province()
      }

      if (address.district) {
        this.entries = [{
          id: address.district.id,
          name: address.district.name,
          'province_id': address.province_id,
          city: {
            name: address.city.name,
            province: {
              name: address.province.name
            }
          }
        }]
      }
      // this.countDistricts = 1


    } else if (id) {
      this.selectedObject.id = id
    }
    if (index && addresses) {
      this.index = index
      this.objectArray = addresses
    } else {
      this.index = 0
      this.objectArray = []
    }


    this.open = true

    this.onApply = onApply
  }

  mounted() {

  }

  changeDistrict(val: any) {
    console.log(val)
    if (this.selectedObject && val && val.id)
      this.selectedObject.district_id = val.id
    if (this.selectedObject && val && val.city) {
      this.selectedObject.city_id = val.city_id
      this.selectedObject.city = new City()
      this.selectedObject.city.id = val.city_id
      this.selectedObject.city.name = val.city
    }
    if (this.selectedObject && val && val.province) {
      this.selectedObject.province_id = val.province_id
      this.selectedObject.province = new Province()
      this.selectedObject.province.id = val.province_id
      this.selectedObject.province.name = val.province
    }

  }

  @Watch('search')
  async onSearchChanged(val: string, oldValue: string) {
    // Items have already been loaded
    //
    if (val === null) return
    if (this.districtItems.length > 0) {
      const found = this.districtItems.filter(obj => val == obj.name)
      if (found.length >= 1) {
        return
      }
    }


    // // Items have already been requested
    // if (this.isLoadingDistricts) return
    console.log([oldValue, val])

    if (val && val.length < 3) return

    this.isLoadingDistricts = true

    // Lazily load input items
    const url = Helper.setting.district.getListAPI + '?keyword=' + val
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      // this.countDistricts = data.count
      this.entries = data.districts

      if (this.entries.length == 0) {

        if (this.selectedObject) {
          this.selectedObject.district_id = null;
          this.selectedObject.city_id = null
          this.selectedObject.province_id = null
          if (this.selectedObject.city)
            this.selectedObject.city.name = ''
          if (this.selectedObject.province)
            this.selectedObject.province.name = ''
        }
      }
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadingDistricts = false
  }

  deletingObject() {

  }

  async editLocation() {
    if (!this.selectedObject) return
    this.$root.$emit('openLocationPicker', {
      option: {
        keyword: `${this.selectedObject.name} ${this.selectedObject.address} ${this.selectedObject.district} ${this.selectedObject.province} ${this.selectedObject.zip_code}`
        , lat: this.selectedObject.cache_lat, lng: this.selectedObject.cache_lng
      }, onApply: async (result) => {
        if (!this.selectedObject) return
        // this.google_isLoad = true
        console.log('editLocation apply', result)

        this.selectedObject.cache_lat = result.lat
        this.selectedObject.cache_lng = result.lng

        this.selectedObject.gis_lat = result.lat
        this.selectedObject.gis_lng = result.lng

        // this.google_isLoad = false
      }
    })
  }

  medias: Media[] = []

  onImagePicked(e) {
    try {
      const fr = new FileReader()
      fr.readAsDataURL(e)
      fr.addEventListener('load', () => {
        this.medias.push(new Media(fr.result))
        //var address = clone(this.selectedObject)
        // debugger
      })
    }catch (e) {
      this.$root.$emit('onError', {message: "File not support"})
    }
  }


  async deletingMedia(media: Media) {
    this.$confirm('ยืนยันลบรูป?').then(res => {
      if (res) {
        this.deleteMedia(media)
      }
    })

  }

  async deleteMedia(media: Media) {
    try {
      if (media.id == null) {
        this.medias = this.medias.filter(object => object !== media)
        return
      }

      media = Object.setPrototypeOf(media, Media.prototype)

      const response: SimpleResponse = await media?.delete()
      if (this.medias) {
        this.medias = this.medias.filter(object => object.id != media?.id)
      }
      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
  }

};

</script>
